import { render, staticRenderFns } from "./Arrival.vue?vue&type=template&id=4948e33c"
import script from "./_arrival.js?vue&type=script&lang=js&external"
export * from "./_arrival.js?vue&type=script&lang=js&external"
import style0 from "./_arrival.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports